import { render, staticRenderFns } from "./ContactForm.vue?vue&type=template&id=7b5a5308&"
import script from "./ContactForm.vue?vue&type=script&lang=js&"
export * from "./ContactForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseInfoCard: require('/opt/buildhome/repo/components/base/InfoCard.vue').default,BaseTextField: require('/opt/buildhome/repo/components/base/TextField.vue').default,BaseTextarea: require('/opt/buildhome/repo/components/base/Textarea.vue').default,BaseBtn: require('/opt/buildhome/repo/components/base/Btn.vue').default})


/* vuetify-loader */
import installComponents from "!../../node_modules/@nuxtjs/vuetify/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})
